<template>
  <!-- Bot section layout -->
  <template v-if="isBotRoute">
    <HeaderBar @open-menu="handleOpenMenu" />
    <SideBar :isVisible="isMenuOpen" @open-menu="handleOpenMenu" />
    <SplashScreen v-if="isLoading" />
    <router-view v-else id="workzone" @open-menu="handleOpenMenu" @close-menu="handleCloseMenu"></router-view>
    <FooterBar />
  </template>

  <!-- Portfolio section layout -->
  <template v-else>
    <PortfolioHeader />
    <SplashScreen v-if="isLoading" />
    <router-view v-else id="portfolio-workzone"></router-view>
  </template>
</template>

<script>
import FooterBar from './components/FooterBar.vue';
import HeaderBar from './components/HeaderBar.vue'
import PortfolioHeader from './components/PortfolioHeader.vue';
import SideBar from './components/SideBar.vue';
import UrlLoaderService from '@/services/urlLoader';
import SplashScreen from './views/SplashScreen.vue';

export default {
  name: 'App',
  components: {
    HeaderBar,
    FooterBar,
    PortfolioHeader,
    SideBar,
    SplashScreen
  },
  async created() {
    if (localStorage.getItem('10-4-Token')) {
      try {
        let res = await UrlLoaderService.get('/dashboard/validate-token');
        if (res.status === 200) {
          this.$store.dispatch('login');
        }
      } catch (error) {
        this.errorMessage = 'There was an error while validating token.';
        console.error(error);
      }
    }
  },
  data() {
    return {
      isMenuOpen: false,
      isLoading: false
    };
  },
  computed: {
    isBotRoute() {
      return this.$route.path.startsWith('/bot');
    }
  },
  methods: {
    handleOpenMenu() {
      this.isMenuOpen = !this.isMenuOpen; // Toggle the menu
    },
    handleCloseMenu() {
      this.isMenuOpen = false;
    }
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  }
}
</script>
<style>
:root {
  --primary: var(--color-500);
  --card-bg: #242f41;
  --secondary: var(--card-bg);
  --text: var(--color-50);
  --background: #1a1f2e;
  --color-link: var(--primary);
  --footer-color-link: #6b6b6b;
  --color-selection: var(--color-500);

  /** Color Palette */
  --color-50: #fef2f3;
  --color-100: #fde6e8;
  --color-200: #fbd0d6;
  --color-300: #f7aab4;
  --color-400: #f27a8d;
  --color-500: #e84b68;
  --color-600: #d93f63;
  --color-700: #b31d44;
  --color-800: #961b3f;
  --color-900: #801b3b;
  --color-950: #470a1c;

  --header-height: 60px;

  font-family: Inter, system-ui, Avenir, Helvetica, Arial, sans-serif;
  line-height: 1.5;
  font-weight: 400;
  color: var(--text);
  background-color: var(--background);
}

body,
html,
#app {
  margin: 0;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}

body {
  display: flex;
  flex-direction: column;
}

a {
  cursor: pointer;
  text-decoration: none;
  color: var(--color-link);

  &:hover {
    text-decoration: underline;
  }
}

h1 {
  margin-bottom: 2rem;
  text-align: center;
}

#workzone {
  flex: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  margin-bottom: 2rem;
}

#portfolio-workzone {
  flex: 1;
  width: 100%;
}

#app {
  width: 100%;
  display: flex;
  flex-direction: column;
}

::-moz-selection {
  background-color: var(--color-selection);
  color: #fff;
}

::selection {
  background-color: var(--color-selection);
  color: #fff;
}

@media (max-width: 768px) {
  #workzone {
    padding: 0 1rem;
  }

  body {
    overflow-x: hidden;
  }
}
</style>
